import { createAsyncThunk } from '@reduxjs/toolkit';
import GetthresholdService from 'modules/inbound/entriesST12/application/getThresholdUseCase';
import { getWorkshopId } from '.';
import GetDLZDataService from 'modules/inbound/entriesST12/application/getDLZDataUseCase';
import GetExternalWarehousesSaturationService from 'modules/inbound/entriesST12/application/getExternalWarehousesSaturationUseCase';
import SetDLZDataService from 'modules/inbound/entriesST12/application/setDLZDataUseCase';
import SetthresholdService from 'modules/inbound/entriesST12/application/setThresholdUseCase';

const getThresholdData = createAsyncThunk(
  'entriesST12/getThresholdData',
  async (_, { getState }) => {
    const appState = getState();
    const workshopId: string = getWorkshopId(appState);

    const queryParams = {
      workshop_id: workshopId
    };
    const response = await GetthresholdService.execute(queryParams);
    return response;
  }
);

const getDLZData = createAsyncThunk('entriesST12/getDLZData', async () => {
  const response = await GetDLZDataService.execute();
  return response;
});

const getExternalWarehousesSaturation = createAsyncThunk(
  'entriesST12/getExternalWarehousesSaturation',
  async () => {
    const response = await GetExternalWarehousesSaturationService.execute();
    return response;
  }
);
const setDLZData = createAsyncThunk(
  'entriesST12/setDLZData',
  async (queryParams: { dlz: number; threshold_capacity: string }) => {
    const response = await SetDLZDataService.execute(queryParams);
    return response;
  }
);
const setThresholdData = createAsyncThunk(
  'entriesST12/setThresholdData',
  async (queryParams: { workshop_id: string; threshold_capacity: string }) => {
    const response = await SetthresholdService.execute(queryParams);
    return response;
  }
);

export {
  getThresholdData,
  getDLZData,
  getExternalWarehousesSaturation,
  setDLZData,
  setThresholdData
};
